import { openTrainingSubmitWindow } from "@/page/training/trainingSubmitWindow";

// 데이터셋 화면(목록 행·카드, 북마크 메뉴, 상세 헤더)이 함께 쓰는 학습 진입점. 시드 역할은 항상
// "train" 이다(역할과 가중치 조정은 위저드가 소유한다). 제출 뒤 상세 열기는 위저드가 완료 toast 로
// 제안한다.
export function openTrainingSubmitWindowForDataset(dataset: {
  uuid: string;
  displayName: string;
}): void {
  openTrainingSubmitWindow({
    initialDataset: {
      uuid: dataset.uuid,
      label: dataset.displayName,
      role: "train",
      weight: null,
      annotationSetUuid: null,
    },
  });
}
